export default __webpack_public_path__ + "static/media/merz-slogan.8d73d525.png";